import { LocationType } from '@talon/web/lib/api';
import { Box, DateInput, RadioButtonGroup, Text } from 'grommet';
import { useEffect } from 'react';
import { fromDateInputChange, formatDateOnly } from '../../../../utils/dateOnly';
import { IAddress } from '../../../../utils/decodeGoogle';
import { Location } from '../../project-home';

import { Hint } from '..';
interface IShootTabProps {
  geography?: string;
  union?: string;
  firstSessionDate?: string;
  place?: IAddress;
  locationType?: LocationType;
  setShoot: (value: string) => void;
  setUnion: (value: string) => void;
  setFirstSessionDate: (value: string) => void;
  setPlace: (place: IAddress | undefined) => void;
  setLocationType: (value?: LocationType) => void;
}

export const ShootTab = ({
  geography,
  union,
  firstSessionDate,
  place,
  locationType,
  setShoot,
  setUnion,
  setFirstSessionDate,
  setPlace,
  setLocationType,
}: IShootTabProps) => {
  /** Effects **/

  useEffect(() => {
    if (geography === 'offshore') {
      setUnion('nonunion');
      setPlace(undefined);
      setLocationType(undefined);
    }
  }, [geography, setUnion, setPlace, setLocationType]);

  /** Render **/
  return (
    <Box pad="medium" gap="medium" overflow={{ vertical: 'auto' }} direction="row" height={{ max: 'large' }}>
      <Box direction="column" width="50%" gap="medium">
        <Text>Alright! Now, where will the shoot(s) take place?</Text>
        <Box gap="small">
          <RadioButtonGroup
            direction="column"
            name="geography"
            options={[
              { label: 'USA', value: 'usa' },
              { label: 'Offshore', value: 'offshore' },
            ]}
            value={geography}
            onChange={(e) => setShoot(e.target.value)}
          />
          {geography === 'usa' && (
            <Box pad="small">
              <Text>Where in the USA will the shoot be? If you don't know, you can leave this field blank.</Text>
              <Location id="new" place={place} updatePlace={setPlace} />
            </Box>
          )}
        </Box>
      </Box>
      <Box direction="column" width="50%">
        <Text>... and when will the first session be?</Text>
        <Box gap="small" direction="row" align="center">
          <Text>{firstSessionDate && formatDateOnly(firstSessionDate)}</Text>
          <DateInput
            value={firstSessionDate}
            onChange={({ value }) => setFirstSessionDate(fromDateInputChange(value))}
          />
        </Box>
        <Text>Talent will:</Text>
        <RadioButtonGroup
          direction="column"
          name="union"
          options={[
            { label: 'Return to the reporting site EOD', value: LocationType.Nearby },
            { label: 'Stay overnight', value: LocationType.Distant },
          ]}
          value={locationType}
          onChange={(e) => setLocationType(e.target.value as unknown as LocationType)}
        />
        <Text>Will this be a union or non-union shoot?</Text>
        <RadioButtonGroup
          direction="column"
          name="union"
          options={[
            { label: 'Union', value: 'union' },
            { label: 'Non-Union', value: 'nonunion' },
          ]}
          value={union}
          onChange={(e) => setUnion(e.target.value)}
        />

        {geography === 'offshore' && (
          <Box pad="small">
            <Hint>
              <Text>Since this shoot is offshore, it is automatically non-union.</Text>
            </Hint>
          </Box>
        )}
      </Box>
    </Box>
  );
};
